import React, { useMemo } from "react"
import Image from "next/image"

import { OMReference, OMUniverse } from "@apptivity-lab/firmament-node-sdk"

import AffAttendeeProfile from "../AffAttendeeProfile"
import AffRating from "../AffRating"

import StarRatingView from "@firmament-packages/ratings/components/StarRatingView"

const AffRatingCell: React.FunctionComponent<{
    variant: "MEDIUM_LIST",
    rating: AffRating
}> = ({ variant, rating }) => {
    const attendeeProfile = OMUniverse.shared.currentUser?.user?.attendeeProfile()
    const submitterProfile = useMemo(() => {
        if (!rating.submitter) {
            return null
        }
        return new OMReference(AffAttendeeProfile, rating.submitter.id).actualObject
    }, [rating])

    return (
        <div className="snap-center min-w-[100%] max-w-[100%] bg-white-900">
            <div className="flex items-center gap-x-[8px]">
                <div className="relative w-[24px] h-[24px] bg-white-900 rounded-full overflow-hidden">
                    <Image width="24" height="24" objectFit="cover"
                        src={submitterProfile?.photo?.actualObject?.preview || "/images/ic_avatar.svg"}
                        alt={submitterProfile?.name || "Submitter Profile Photo"} />
                </div>

                <span className="text-black-900 text-footnote">{submitterProfile?.fullName}</span>
            </div>

            <div className="mt-[8px] flex gap-x-[12px] items-center">
                <StarRatingView ratingsAverage={rating.overall || 0} />
                <span className="text-black-700 text-caption2">
                    {rating.createdAt.toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                        timeZone: attendeeProfile?.timezone || undefined
                    })}
                </span>
            </div>

            <p className="mt-[12px] text-black-900 text-body">{rating.review}</p>
        </div>
    )
}

export default AffRatingCell
